import { HighlightOff } from "@mui/icons-material";
import {
  Avatar,
  Button,
  Backdrop,
  CircularProgress,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  TextField,
  FormHelperText,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ServiceApi } from "../../services/index.service";
import { useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import { emailValidator, nameValidator } from "../../utils";

const initDetails = {
  fname: "",
  lname: "",
  email: "",
};

export const AddNewGuest = ({
  open = false,
  handleClose = () => {},
  fetchUpdatedGuests = () => {},
}) => {
  const serviceapi = new ServiceApi();
  const { storage } = useSelector((state) => state);
  const [details, setDetails] = useState(initDetails);
  const [flavors, setFlavors] = useState([]);
  const [selectedFlavors, setSelectedFlavors] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [modified,setModified]=useState(false)

  const handleInputChange = (e) => {
    const { value, name } = e.target;
    setDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (storage?.store?.intStoreID) {
      getGuestFlavors(storage?.store);
    }
  }, [storage?.store?.intStoreID]);

  const getGuestFlavors = async (intStoreID) => {
    setLoading(true);
    const guestFlavors = await serviceapi?.fetchGuestFlavors(
      storage?.store?.intStoreID
    );
    setLoading(false);
    setFlavors(guestFlavors.data);
  };

  const getSignedUrl = (file = "") => {
    const fileData = file?.replace("'", "");
    return fileData;
  };

  const handleSingleFlavorToggle = (categoryIndex, flavorIndex, flv) => {
    const item = {
      rfid: flv.rfid,
      cat: flv.Cat,
    };
    const updatedSelectedFlavors = [...selectedFlavors];
    if (!updatedSelectedFlavors[categoryIndex]) {
      updatedSelectedFlavors[categoryIndex] = [];
    }
    const isFlavorSelectedIndex = updatedSelectedFlavors[
      categoryIndex
    ].findIndex((selectedItem) => selectedItem.rfid === flv.rfid);
    if (isFlavorSelectedIndex !== -1) {
      updatedSelectedFlavors[categoryIndex] = updatedSelectedFlavors[
        categoryIndex
      ].filter((selectedItem) => selectedItem.rfid !== flv.rfid);
    } else {
      updatedSelectedFlavors[categoryIndex].push(item);
    }
    setSelectedFlavors(updatedSelectedFlavors);
  };

  const handleSelectAll = (categoryIndex) => {
    const allFlavors =
      flavors[categoryIndex]?.flavors.map((flavor) => ({
        rfid: flavor.rfid,
        cat: flavor.Cat,
      })) || [];
    setSelectedFlavors((prevSelectedFlavors) => {
      const updatedSelectedFlavors = [...prevSelectedFlavors];
      updatedSelectedFlavors[categoryIndex] = allFlavors;
      return updatedSelectedFlavors;
    });
  };

  const handleDeselectAll = (categoryIndex) => {
    setSelectedFlavors((prevSelectedFlavors) => {
      const updatedSelectedFlavors = [...prevSelectedFlavors];
      updatedSelectedFlavors[categoryIndex] = [];
      return updatedSelectedFlavors;
    });
  };

  const isFlavorSelected = (categoryIndex, rfid) => {
    return (
      selectedFlavors[categoryIndex]?.some((item) => item.rfid === rfid) ||
      false
    );
  };

  const displaySnackBarMessages = (errorMessage, type) => {
    enqueueSnackbar(errorMessage, {
      anchorOrigin: { vertical: "top", horizontal: "right" },
      variant: type,
    });
  };

  const handleAddGuest = async () => {
    setModified(true)
    try {
      const finalSelectedList = selectedFlavors?.reduce(
        (accumulator, currentValue) => {
          if (Array.isArray(currentValue)) {
            return [...accumulator, ...currentValue];
          } else if (currentValue !== null && currentValue !== undefined) {
            return [...accumulator, currentValue];
          } else {
            return accumulator;
          }
        },
        []
      );
      if (!details?.fname  || nameValidator(details.fname)) {
        return
        // displaySnackBarMessages("Please enter valid first name", "error");
      } else if (!details?.lname  || nameValidator(details.lname)) {
        // displaySnackBarMessages("Please enter valid last name", "error");
        return

      } else if (!details.email || emailValidator(details.email)) {
        // displaySnackBarMessages("Please enter valid email", "error");
        return

      } else if (finalSelectedList?.length === 0) {
        displaySnackBarMessages("Please select atleast one flavor", "error");
      } else {
        const guestPayload = {
          ...details,
          intStoreID: storage?.store?.intStoreID,
          flavors: finalSelectedList,
        };
        setBtnLoading(true)
        const createGuestResponse = await serviceapi.createGuest(guestPayload);
        setBtnLoading(false)
        if (createGuestResponse?.status === 200) {
            setDetails(initDetails);
            setSelectedFlavors([]);
            handleClose(false);
            displaySnackBarMessages("Guest Added Successfully", "success");
            fetchUpdatedGuests();
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <Dialog fullScreen open={open} onClose={handleClose}>
        <DialogTitle>New Guest Data Entry</DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ position: "absolute", right: 8, top: 12 }}
        >
          <HighlightOff />
        </IconButton>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading || btnLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        {flavors?.length > 0 && (
          <span>
            <DialogContent dividers sx={{ padding: "24px", maxHeight: "calc(100vh - 130px)" }}>
              <Grid container spacing={3}>
                <Grid item sm={4}>
                  <FormControl fullWidth size="small">
                    <TextField
                      name="fname"
                      label="First Name"
                      placeholder="First Name"
                      value={details?.fname}
                      onChange={handleInputChange}
                      InputLabelProps={{
                        sx: {
                          fontSize: "14px",
                          top: "-1vh",
                          "&.MuiInputLabel-shrink": { top: 0 },
                        },
                      }}
                    />
                     {modified && nameValidator(details?.fname,'First Name') && (
                      <FormHelperText style={{ color: "red" }}>
                      {nameValidator(details?.fname,'First Name')}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item sm={4}>
                  <FormControl fullWidth size="small">
                    <TextField
                      name="lname"
                      label="Last Name"
                      placeholder="Last Name"
                      value={details?.lname}
                      onChange={handleInputChange}
                      InputLabelProps={{
                        sx: {
                          fontSize: "14px",
                          top: "-1vh",
                          "&.MuiInputLabel-shrink": { top: 0 },
                        },
                      }}
                    />
                    {modified && nameValidator(details?.lname,'First Name') && (
                      <FormHelperText style={{ color: "red" }}>
                      {nameValidator(details?.lname,'Last Name')}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item sm={4}>
                  <FormControl fullWidth size="small">
                    <TextField
                      name="email"
                      label="Email"
                      placeholder="xxxxxx@email.com"
                      value={details?.email}
                      onChange={handleInputChange}
                      InputLabelProps={{
                        sx: {
                          fontSize: "14px",
                          top: "-1vh",
                          "&.MuiInputLabel-shrink": { top: 0 },
                        },
                      }}
                    />
                    <div style={{ color: "red" }}>
                    {modified && emailValidator(details?.email) && (
                      <FormHelperText style={{ color: "red" }}>
                      {emailValidator(details?.email)}
                      </FormHelperText>
                    )}
                  </div>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container spacing={3} marginTop={0}>
                {flavors?.map((category, index) => (
                  <Grid key={index} item xs={12} sm={4} md={4} lg={4} xl={4}>
                    <div className="flex justify-between items-center"
                      style={{ borderWidth: '1px 1px 0px 1px', borderColor: '#e2e2e2', background: 'rgba(250, 250, 250, 1)', borderRadius: '5px 5px 0px 0px', padding: '10px' }}>
                      <h2 className="text-sm font-medium ml-1 mb-1">
                        {category.product_type_name} {selectedFlavors[index]?.length>0 && <>({ selectedFlavors[index]?.length }) </>}                    </h2>
                      <div className="text-xs">
                        <Link
                          component="button"
                          onClick={() => handleDeselectAll(index)}
                        >
                          Deselect All
                        </Link>
                        <Link
                          component="button"
                          className="ml-4"
                          onClick={() => handleSelectAll(index)}
                        >
                          Select All
                        </Link>
                      </div>
                    </div>
                    <Card
                      sx={{
                        maxHeight: 300,
                        height: "100%",
                        overflowY: "auto",
                        border: '1px solid #e2e2e2',
                        borderRadius: '0px 0px 5px 5px',
                        boxShadow: 'none'
                      }}
                    >
                      <CardContent sx={{ padding: '0px', paddingLeft: 0 }}>
                        <List
                          dense
                          sx={{
                            width: "100%",
                            bgcolor: "background.paper",
                          }}
                        >
                          {category.flavors?.map((flv, flvIndex) => (
                            <ListItem key={flvIndex} disablePadding>
                              <ListItemButton sx={{paddingRight: '0px', cursor: 'default'}}>
                                <ListItemAvatar>
                                  <Avatar
                                    className="w-8 h-8 text-sm"
                                    src={
                                      getSignedUrl(flv?.imageURL) ||
                                      "../assets/icons/circle.png"
                                    }
                                  />
                                </ListItemAvatar>
                                <ListItemText primary={flv.Flavor} />
                                <Checkbox
                                  className="mr-4"
                                  edge="end"
                                  onChange={() =>
                                    handleSingleFlavorToggle(
                                      index,
                                      flvIndex,
                                      flv
                                    )
                                  }
                                  checked={isFlavorSelected(index, flv.rfid)}
                                  inputProps={{ "aria-label": "controlled" }}
                                  sx={{
                                    "&.Mui-checked": {
                                      color: "#C12637"
                                    },
                                  }}
                                />
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </List>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button
                variant="contained"
                className="bg-gray-200 shadow-none text-gray-800 capitalize"
                onClick={handleClose}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                className="bg-primary shadow-none text-white capitalize ml-3 mr-6"
                onClick={handleAddGuest}
              >
                Add Guest
              </Button>
            </DialogActions>
          </span>
        )}
        {!loading && flavors.length === 0 && (
          <div
            className=""
            style={{
              padding: "10px",
              backgroundColor: "#FFF",
              color: "#000",
              textAlign: "center",
            }}
          >
            <h1 className="text-base">No Flavors found for this store</h1>
          </div>
        )}
      </Dialog>
    </>
  );
};
